export default "__VITE_ASSET__1H71L1nm__"